import { render, staticRenderFns } from "./HowWorksV2Block.vue?vue&type=template&id=08149158&scoped=true&"
import script from "./HowWorksV2Block.vue?vue&type=script&lang=js&"
export * from "./HowWorksV2Block.vue?vue&type=script&lang=js&"
import style0 from "./HowWorksV2Block.vue?vue&type=style&index=0&id=08149158&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08149158",
  null
  
)

export default component.exports